import { render, staticRenderFns } from "./completed-training-table.vue?vue&type=template&id=44d31ccd&"
import script from "./completed-training-table.vue?vue&type=script&lang=js&"
export * from "./completed-training-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports